import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from 'app/authentication/auth/auth.service';
import { redirectToServerSignIn } from 'app/authentication/auth/auth-redirect.util';
import { IptvClientFlagsService } from 'app/authentication/auth/iptv-client-flags.service';
import { switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {
    constructor(
        private _authService: AuthService,
        private _iptvFlags: IptvClientFlagsService,
        private _router: Router
    ) {
    }

    private _check(redirectURL: string): Observable<boolean> {
        return this._authService.check()
            .pipe(
                switchMap((authenticated) => {
                    if (!authenticated) {
                        if (this._iptvFlags.hideLogin) {
                            return of(true);
                        }
                        return this._iptvFlags.load().pipe(
                            switchMap((flags) => {
                                if (flags.hide_login) {
                                    return of(true);
                                }
                                redirectToServerSignIn(redirectURL);
                                return of(false);
                            })
                        );
                    }

                    const workspaceBlocked = this._authService.isWorkspaceSelectionRequired()
                        && !this._authService.hasWorkspaceSelection()
                        && !redirectURL.startsWith('/dashboard');

                    if (workspaceBlocked) {
                        this._router.navigate(['/dashboard']);
                        return of(false);
                    }

                    return of(true);
                })
            );
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return this._check(state.url);
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this._check(state.url);
    }

    canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
        return this._check('/');
    }
}
